// extracted by mini-css-extract-plugin
module.exports = {"cards":"SeoBestProducts_cards__itMvJ","gridCards":"SeoBestProducts_gridCards__OXmxF","title":"SeoBestProducts_title__DCCUY"};